import { environment } from '@lla-platform/core/core-util'

export const DASHBOARD_API_URL = {
  getTireWidgetInfo: `${environment.apiUrl}/dashboards/tires-widget`,
  getWeeklyTargetWidgetInfo: `${environment.apiUrl}/dashboards/weekly-target-widget`,
  getScheduleWeeks: `${environment.apiUrl}/dashboards/scheduleweeks`,
  getContactsTypeWidgetInfo: `${environment.apiUrl}/dashboards/contacts-type-widget`,
  getArReceivablesWidgetInfo: `${environment.apiUrl}/dashboards/ar-receivables-widget`,
  getReceivablesWidgetInfo: `${environment.apiUrl}/dashboards/receivables-widget`,
  getWeekOverWeek: `${environment.apiUrl}/dashboards/week-over-week`
}
